import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { BRAND } from "../config/brand";

export default function Login() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("");
    const [pw, setPw] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    if (user) return <Navigate to="/dashboard" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        const res = await login(email, pw);
        setLoading(false);
        if (!res.ok) {
            setErr(res.error);
            toast.error(res.error);
        } else {
            toast.success("Accesso effettuato");
            nav("/dashboard");
        }
    };

    return (
        <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
            <div
                className="hidden lg:flex flex-col justify-between p-12 grain"
                style={{
                    backgroundImage:
                        "url(https://static.prod-images.emergentagent.com/jobs/93585fcd-1f53-4bac-bdc5-f9a2ce2b3880/images/9a0d519c0364ed5816f0dc83096b86862a2348cd203f79fd65863facffb451b4.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="flex items-center">
                    <img
                        src={BRAND.logo}
                        alt={BRAND.name}
                        className="h-24 w-auto bg-white px-6 py-3"
                        data-testid="login-brand-logo"
                    />
                </div>
                <div className="bg-white/90 backdrop-blur p-8 max-w-md">
                    <div className="overline mb-3">Financial Control Room</div>
                    <h2 className="text-3xl font-black tracking-tighter leading-tight">
                        La control room finanziaria per agenzie di scommesse.
                    </h2>
                    <p className="mt-4 text-sm text-zinc-600">
                        Unifica cassa, banca, wallet, sospesi clienti e credito fornitore
                        in un'unica dashboard aggiornata in tempo reale. Controlla i
                        flussi dell'agenzia con semplicità, senza fogli Excel e senza
                        complessità contabili.
                    </p>
                </div>
            </div>

            <div className="flex items-center justify-center p-8 md:p-16 bg-white">
                <form
                    onSubmit={submit}
                    className="w-full max-w-md"
                    data-testid="login-form"
                >
                    <div className="overline mb-4">Accedi</div>
                    <h1 className="text-5xl font-black tracking-tighter mb-10">
                        Benvenuto.
                    </h1>

                    <label className="block mb-6">
                        <div className="overline mb-2">Email</div>
                        <input
                            type="email"
                            className="inp"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            data-testid="login-email-input"
                            autoComplete="email"
                        />
                    </label>

                    <label className="block mb-2">
                        <div className="overline mb-2">Password</div>
                        <input
                            type="password"
                            className="inp"
                            value={pw}
                            onChange={(e) => setPw(e.target.value)}
                            required
                            data-testid="login-password-input"
                            autoComplete="current-password"
                        />
                    </label>
                    <div className="text-right mb-6">
                        <Link
                            to="/forgot-password"
                            className="text-xs text-zinc-600 hover:text-ink underline underline-offset-4"
                            data-testid="link-to-forgot-password"
                        >
                            Password dimenticata?
                        </Link>
                    </div>

                    {err && (
                        <div className="mb-4 p-3 border border-red-600 text-red-600 text-sm">
                            {err}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="btn-primary w-full"
                        data-testid="login-submit-button"
                    >
                        {loading ? "Accesso…" : "Entra"}
                    </button>

                    <div className="mt-8 text-sm text-zinc-600">
                        Non hai un account?{" "}
                        <Link
                            to="/register"
                            className="font-bold underline underline-offset-4"
                            data-testid="link-to-register"
                        >
                            Registrati
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
